import { ISearchUserData } from '@/lib/interface';
import { IHasClassName } from '@/interfaces';
import UserCard from './UserCard';

type TUser = Omit<ISearchUserData, 'diamondWallet'>;

export type TProps = IHasClassName & {
  onClickBtnDelete?: (user: TUser) => void;
  onClickBtnSee?: (user: TUser) => void;
  user: TUser;
}

export default UserCard;
